
export class verifyAccountResponse{
    
    data:verified;
    // constructor(data:verified){
    //   this.data=data;
    // }
}

interface verified{
    accountNumber:string;
    name:string;
    sortCode:string;
}